import React from "react";
import "./About.scss";

export default function About() {
  const [showVideo, setShowVideo] = React.useState(false);
  return (
    <section id="about" className="about-section" aria-labelledby="about-heading">
      <div className="site-width about-layout">
        <div className="about-heading"><p className="eyebrow">ABOUT / 02</p><h2 id="about-heading">A partner for the<br /><em>hard parts.</em></h2></div>
        <div className="about-story">
          <p className="about-lead">I’m a software consultant who enjoys making complicated things feel straightforward.</p>
          <p>Over 12 years in the industry, I’ve worked with teams across countries and sectors—from government services to commerce products. My focus is building dependable frontends, with the full-stack perspective to understand the system around them.</p>
          <p>I hold a master’s degree in computer science and work with a network of trusted freelancers when a project needs a broader team.</p>
          <div className="about-actions"><a className="text-link" download href="/cv.pdf">Download my CV <span aria-hidden="true">↗</span></a><a className="text-link" href="mailto:TobiasKlock84@gmail.com">Start a conversation <span aria-hidden="true">↗</span></a></div>
          <div className="intro-video"><button className="intro-video-toggle" type="button" aria-expanded={showVideo} onClick={() => setShowVideo(!showVideo)}>Watch my introduction <span aria-hidden="true">↗</span></button>{showVideo && <div className="video-frame"><iframe src="https://www.youtube-nocookie.com/embed/Kt_leYE22W8" title="Tobias Klock introduction video" allowFullScreen /></div>}</div>
        </div>
      </div>
    </section>
  );
}
